import MapLayerType from "./mapLayerType";

const getMapLayerTypeDisplayName = (mapLayerType: MapLayerType) => {
  let displayName = "";

  switch (mapLayerType) {
    case MapLayerType.ThematicLayer:
      displayName = "Thematic Layer";
      break;

    case MapLayerType.GeospatialLayer:
      displayName = "Geospatial Layer";
      break;

    default:
      break;
  }

  return displayName;
};

const mapLayerTypeHelper = {
  getMapLayerTypeDisplayName,
};

export default mapLayerTypeHelper;
